
import { Component, Prop } from 'vue-property-decorator';
import VFormBuilder from '../../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import { Permission } from '@/enums/Permission';
import StackedForm from '../../../mixins/StackedForm';
import { mixins } from 'vue-class-component';

@Component({
  components: { VFormBuilder },
})
export default class CopyVenueForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get items() {
    return [
      {
        name: 'direction',
        type: InputType.Select,
        label: 'sync.form.direction',
        rules: 'required',
        items: this.directions,
      },
      { name: 'newName', type: InputType.Text, label: 'venue.form.newName' },
      { name: 'asSlave', type: InputType.Checkbox, label: 'venue.form.asSlave' },
    ];
  }

  get directions() {
    const items = this.$isAdmin()
      ? ['d2d', 'd2p', 'p2d', 'p2p']
      : [
          ...(this.$can(Permission.SYNC_DEV_TO_DEV) ? ['d2d'] : []),
          ...(this.$can(Permission.SYNC_DEV_TO_PROD) ? ['d2p'] : []),
          ...(this.$can(Permission.SYNC_PROD_TO_DEV) ? ['p2d'] : []),
          ...(this.$can(Permission.SYNC_PROD_TO_PROD) ? ['p2p'] : []),
        ];

    return items.map((val: string) => ({
      text: this.$t(`sync.directions.${val}`),
      value: val,
    }));
  }
}
